var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs is-boxed"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'withdrawal-requests' },"active-class":"is-active","tag":"li"}},[_c('a',[_vm._v("Withdrawal Requests")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'operations-awaiting-antifraud' },"active-class":"is-active","tag":"li"}},[_c('a',[_vm._v("Operations Awaiting Anti Fraud Action")])])],1)])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/payment-system/index.vue?vue&type=template&id=5ef9aa1a
// module id = 8C1h
// module chunks = 0